/**
 * Galeria PDP — partição estrita por desenho/cor (sem mix).
 *
 * Cada índice do catálogo pertence a exatamente um desenho:
 * - Desenhos ordenados pela 1ª foto ligada (âncora)
 * - Faixa i: [início → fim) contíguo, sem overlap
 *   · 1º desenho: [0 → âncora do próximo) — exceto Taurus (leading misturado)
 *   · Demais: [âncora deste → âncora do próximo ou fim)
 * - Na faixa: órfãs + fotos ligadas só a este desenho
 * - Ligadas fora da faixa (Taurus): sempre incluídas no desenho correto
 * - Ordem: ligadas ao desenho primeiro, depois órfãs na ordem do catálogo
 *
 * Órfãs entre duas âncoras (quando âncora anterior > 0):
 *   · 1ª órfã logo após a âncora anterior → fica no desenho anterior
 *   · Demais órfãs do intervalo → desenho seguinte (+ faixa própria)
 * Play Snake (1ª âncora = 0): faixa clássica sem repasse de intervalo.
 *
 * Exceção tail (Signal Gear): âncoras no final do catálogo.
 */
(function (global) {
  'use strict';

  function norm(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function groupForVariant(variant, visualOption) {
    if (!variant) return '';
    var key =
      visualOption === 'option2' ? 'option2' : visualOption === 'option3' ? 'option3' : 'option1';
    return norm(variant[key]) || norm(variant.option1) || '';
  }

  function variantIdMatches(variantIds, variantId) {
    var id = String(variantId);
    for (var i = 0; i < variantIds.length; i += 1) {
      if (String(variantIds[i]) === id) return true;
    }
    return false;
  }

  function isOrphan(image) {
    return !(image.variantIds || []).length;
  }

  function imageMatchesGroupStrict(image, groupValue, allVariants, visualOption) {
    var variantIds = image.variantIds || [];
    if (!variantIds.length) return false;

    var hasMatch = false;
    var vi;
    for (vi = 0; vi < variantIds.length; vi += 1) {
      var variant = null;
      var ai;
      for (ai = 0; ai < allVariants.length; ai += 1) {
        if (String(allVariants[ai].id) === String(variantIds[vi])) {
          variant = allVariants[ai];
          break;
        }
      }
      if (!variant) continue;

      var gName = groupForVariant(variant, visualOption);
      if (!gName) continue;
      if (gName === groupValue) {
        hasMatch = true;
      } else {
        return false;
      }
    }

    return hasMatch;
  }

  function belongsInSegment(image, groupValue, allVariants, visualOption) {
    if (isOrphan(image)) return true;
    return imageMatchesGroupStrict(image, groupValue, allVariants, visualOption);
  }

  function buildAnchorMins(images, groupsOrdered, allVariants, visualOption, imageCount) {
    var anchorMin = {};
    var g;
    for (g = 0; g < groupsOrdered.length; g += 1) {
      anchorMin[groupsOrdered[g]] = imageCount;
    }

    var idx;
    for (idx = 0; idx < imageCount; idx += 1) {
      var variantIds = images[idx].variantIds || [];
      if (!variantIds.length) continue;
      var vi;
      for (vi = 0; vi < allVariants.length; vi += 1) {
        var variant = allVariants[vi];
        if (!variantIdMatches(variantIds, variant.id)) continue;
        var gName = groupForVariant(variant, visualOption);
        if (!gName || anchorMin[gName] == null) continue;
        if (idx < anchorMin[gName]) anchorMin[gName] = idx;
      }
    }

    return anchorMin;
  }

  function globalFirstAnchor(anchorMin, groupsOrdered, imageCount) {
    var minA = imageCount;
    var g;
    for (g = 0; g < groupsOrdered.length; g += 1) {
      var a = anchorMin[groupsOrdered[g]];
      if (a < minA) minA = a;
    }
    return minA >= imageCount ? 0 : minA;
  }

  function hasMixedLeadingOrphans(images, anchorMin, groupsOrdered, imageCount) {
    if (groupsOrdered.length <= 2) return false;

    var firstAnchor = globalFirstAnchor(anchorMin, groupsOrdered, imageCount);
    if (firstAnchor <= 0) return false;

    var idx;
    for (idx = 0; idx < firstAnchor; idx += 1) {
      if (isOrphan(images[idx])) return true;
    }
    return false;
  }

  function isTailPattern(anchorMin, groupsOrdered, imageCount) {
    var groupCount = groupsOrdered.length;
    if (groupCount <= 1) return false;

    var anchors = groupsOrdered.map(function (g) {
      return anchorMin[g];
    });

    return (
      anchors.every(function (a) {
        return a >= imageCount - groupCount;
      }) && Math.max.apply(null, anchors) - Math.min.apply(null, anchors) <= groupCount - 1
    );
  }

  function tailReverseBlockIndices(groupsOrdered, anchorMin, imageCount, groupValue) {
    var groupCount = groupsOrdered.length;
    var leadingCount = globalFirstAnchor(anchorMin, groupsOrdered, imageCount);

    var groupIndex = groupsOrdered.indexOf(groupValue);
    if (groupIndex < 0) return [];

    var chunkIndex = groupCount - 1 - groupIndex;
    var chunkStart = Math.floor((leadingCount * chunkIndex) / groupCount);
    var chunkEnd = Math.floor((leadingCount * (chunkIndex + 1)) / groupCount);

    var indices = [];
    var i;
    for (i = chunkStart; i < chunkEnd; i += 1) {
      indices.push(i);
    }

    var anchor = anchorMin[groupValue];
    if (anchor < imageCount) indices.push(anchor);

    return indices;
  }

  /** 1ª órfã após âncora anterior permanece no desenho anterior (Olist). */
  function isBridgeOrphan(prevAnchor, index, image) {
    return prevAnchor > 0 && index === prevAnchor + 1 && isOrphan(image);
  }

  /** Órfãs do intervalo repassadas ao desenho seguinte (exceto bridge). */
  function isGapOrphanForGroup(prevAnchor, myAnchor, index, image, gi) {
    if (gi <= 0 || prevAnchor <= 0 || !isOrphan(image)) return false;
    if (index <= prevAnchor || index >= myAnchor) return false;
    if (isBridgeOrphan(prevAnchor, index, image)) return false;
    return true;
  }

  /** Órfãs na faixa deste desenho repassadas ao próximo (exceto 1ª após âncora própria). */
  function isDeferredToNextGroup(myAnchor, segmentEnd, index, image) {
    if (myAnchor <= 0 || !isOrphan(image)) return false;
    if (index <= myAnchor || index >= segmentEnd) return false;
    if (index === myAnchor + 1) return false;
    return true;
  }

  /**
   * @param {object} map
   * @param {string} groupValue
   * @returns {string[] | null}
   */
  function computeForGroup(map, groupValue) {
    var meta = map && map.resolver;
    if (!meta || !meta.images || !groupValue) return null;

    var images = meta.images;
    var groupsOrdered = meta.groupsOrdered || [];
    var visualOption = meta.visualOption || map.visualOption || 'option1';
    var allVariants = map.allVariants || [];
    var imageCount = images.length;

    if (groupsOrdered.length <= 1) {
      return images.map(function (img) {
        return String(img.id);
      });
    }

    var anchorMin = buildAnchorMins(images, groupsOrdered, allVariants, visualOption, imageCount);
    var sortedGroups = groupsOrdered.slice().sort(function (a, b) {
      return anchorMin[a] - anchorMin[b];
    });
    var gi = sortedGroups.indexOf(groupValue);
    if (gi < 0) gi = groupsOrdered.indexOf(groupValue);
    if (gi < 0) return null;

    var mixedLeading = hasMixedLeadingOrphans(images, anchorMin, groupsOrdered, imageCount);
    var myAnchor = anchorMin[sortedGroups[gi]];
    var prevAnchor = gi > 0 ? anchorMin[sortedGroups[gi - 1]] : -1;
    var include = {};
    var i;

    if (isTailPattern(anchorMin, groupsOrdered, imageCount)) {
      var idxList = tailReverseBlockIndices(groupsOrdered, anchorMin, imageCount, groupValue);
      for (i = 0; i < idxList.length; i += 1) {
        var tailImg = images[idxList[i]];
        if (belongsInSegment(tailImg, groupValue, allVariants, visualOption)) {
          include[String(tailImg.id)] = true;
        }
      }
      for (i = myAnchor + 1; i < imageCount; i += 1) {
        var tailAfter = images[i];
        if (!isOrphan(tailAfter)) break;
        include[String(tailAfter.id)] = true;
      }
    } else {
      var segmentStart = gi === 0 && !mixedLeading ? 0 : myAnchor;
      var segmentEnd =
        gi < sortedGroups.length - 1 ? anchorMin[sortedGroups[gi + 1]] : imageCount;

      if (gi > 0 && prevAnchor > 0) {
        for (i = prevAnchor + 1; i < myAnchor; i += 1) {
          if (isGapOrphanForGroup(prevAnchor, myAnchor, i, images[i], gi)) {
            include[String(images[i].id)] = true;
          }
        }
      }

      for (i = segmentStart; i < segmentEnd; i += 1) {
        var segImg = images[i];
        if (
          gi < sortedGroups.length - 1 &&
          isDeferredToNextGroup(myAnchor, segmentEnd, i, segImg)
        ) {
          continue;
        }
        if (belongsInSegment(segImg, groupValue, allVariants, visualOption)) {
          include[String(segImg.id)] = true;
        }
      }
    }

    for (i = 0; i < imageCount; i += 1) {
      if (imageMatchesGroupStrict(images[i], groupValue, allVariants, visualOption)) {
        include[String(images[i].id)] = true;
      }
    }

    return orderGroupImageIds(images, include, groupValue, allVariants, visualOption, null);
  }

  /**
   * @param {string|null} featuredId
   * @returns {string[] | null}
   */
  function orderGroupImageIds(images, includeMap, groupValue, allVariants, visualOption, featuredId) {
    var strict = [];
    var other = [];
    var i;

    for (i = 0; i < images.length; i += 1) {
      var id = String(images[i].id);
      if (!includeMap[id]) continue;
      if (imageMatchesGroupStrict(images[i], groupValue, allVariants, visualOption)) {
        strict.push(id);
      } else {
        other.push(id);
      }
    }

    var ordered = strict.concat(other);
    if (!ordered.length) return null;

    if (featuredId != null) {
      var feat = String(featuredId);
      if (includeMap[feat]) {
        ordered = [feat].concat(
          ordered.filter(function (existingId) {
            return existingId !== feat;
          })
        );
      }
    }

    return ordered;
  }

  global.MercadaoPdpGallery = {
    computeForGroup: computeForGroup,
    orderGroupImageIds: orderGroupImageIds,
    imageMatchesGroupStrict: imageMatchesGroupStrict,
    groupForVariant: groupForVariant,
    isTailPattern: isTailPattern,
    hasMixedLeadingOrphans: hasMixedLeadingOrphans,
  };
})(typeof window !== 'undefined' ? window : globalThis);
